import styled from "styled-components";

const StyledUnorderedList = styled.ul`
  padding-left: 0;
  list-style-type: none;

  .list-item-group {
    padding-top: 0.5rem;
    padding-right: 0;
    padding-bottom: 0.5rem;
    border-style: solid;
    border-width: 1px;
    border-color: transparent transparent rgba(0, 0, 0, 0.13);
  }

  .list-item-group:last-child {
    border-bottom-style: none;
  }

  .list-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    grid-gap: 1rem;
  }

  .text {
    font-size: 1.1rem;
    line-height: 1.1;
  }

  .star {
    display: inline;
    font-family: 'Font Awesome 6 Free', sans-serif;
    color: gold;
    font-size: 1rem;
    line-height: 1;
  }

`

export default StyledUnorderedList;
